import { gql } from "@apollo/client";

export const GET_MANUFACTURER_BY_SUBDOMAIN = gql`
  query getManufacturerBySubdomain($subDomain: String!) {
    getManufacturerBySubDomain(subDomain: $subDomain) {
      id
      brand
      subDomain
      email
      firstName
      lastName
      name
      createdAt
      updatedAt
      isBusinessInfo
      isStripeConnected
      isShopifyConnected
      stripeConnectUrl
      type
    }
  }
`;
